export enum UserRole {
  Admin = "Admin",
  Manager = "Manager",
  Operator = "Operator",
  User = "User"
}
